var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSave({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.5,
    clipRule: "evenodd",
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "stroke fill",
    d: "M54.74 40.2a5.7 5.7 0 00-5.7-5.7H25.96a5.7 5.7 0 00-5.7 5.7v22.38h34.48V40.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    className: "stroke",
    d: "M28.66 43.8h17.68m-17.68 9.48h17.68m.36-40.86v11.23a2.97 2.97 0 01-2.96 2.97h-19.6a3.14 3.14 0 01-3.15-3.15V12.42h-1.83a7.44 7.44 0 00-7.44 7.44v35.28a7.44 7.44 0 007.44 7.44h36.68a7.44 7.44 0 007.44-7.44V25.48c0-.96-.39-1.89-1.08-2.56l-9.75-9.49a3.58 3.58 0 00-2.5-1.01H46.7zm-25.71 0H46.7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.1e02b0ccdc1e90851c68067fc13f6d3e.svg";
export { ForwardRef as ReactComponent };